import { IModel, IAttribute } from '../base/annotation';
import { Metamodel } from 'app/model/base/model';

import { FormatDatasetV2 } from 'app/model/dataset/dataset.v2';
import { format } from 'app/shared/utils/string.util';
import { ModelConstants } from 'shell-models-lib';

@Metamodel.model({
    name: ModelConstants.binaryDataset,
    display: [
        format(stringResources.ModelName_DatasetTemplate, stringResources.ModelName_BinaryDataset),
        format(stringResources.ModelName_DatasetsTemplate, stringResources.ModelName_BinaryDataset)
    ]
})
export class BinaryDataset extends FormatDatasetV2 {
    public static readonly MODEL: IModel;
    public static readonly COMPRESSION_CODEC: IAttribute;
    public static readonly COMPRESSION_LEVEL: IAttribute;

    @Metamodel.attribute({
        display: stringResources.ModelName_CompressionCodec,
        association: 'COMPRESSION_CODEC',
        templatable: true
    })
    public compressionCodec: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_CompressionLabel,
        association: 'COMPRESSION_LEVEL',
        templatable: true
    })
    public compressionLevel: string;

    public constructor(name?: string, description?: string) {
        super(name, description);
    }
}
